import { render, staticRenderFns } from "./jt808-devices.vue?vue&type=template&id=bfbb287c&scoped=true"
import script from "./jt808-devices.vue?vue&type=script&lang=js"
export * from "./jt808-devices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfbb287c",
  null
  
)

export default component.exports